/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Plan_Pending_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel downgrade" |
*
* @param {Partner_Manage_Plan_Pending_CancelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_pending_cancel = /** @type {((inputs?: Partner_Manage_Plan_Pending_CancelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_Pending_CancelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Downgrade abbrechen")
	return /** @type {LocalizedString} */ ("Cancel downgrade")
});